// extracted by mini-css-extract-plugin
module.exports = {"mask":"Mask_mask__1Nzzr","square":"Mask_square__3jsnO Mask_mask__1Nzzr","rounded":"Mask_rounded__13dnU Mask_mask__1Nzzr","circle":"Mask_circle__1VypF Mask_mask__1Nzzr"};